import { Tooltip } from '@mui/material';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import '../../css/botao.css';
import Configuracao from '../../util/Configuracao';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';

class ProcuradorSessao extends ReactComponent {
    opcoesProcuradoresSIJ = [];
    opcoesProcuradoresPJe = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            opcoesProcuradoresSIJ: observable,
            opcoesProcuradoresPJe: observable,
            existeSessaoSIJ: computed,
            existeSessaoPJe: computed,
            sessoes: computed,
            desabilitarAutoComplete: computed
        });
    }

    async componentDidMount() {
        try {
            if (this.existeSessaoSIJ) {
                this.opcoesProcuradoresSIJ = this.converterOpcoesProcuradores(this.dominioStore.procuradoresSIJ);
            }
            if (this.existeSessaoPJe) {
                this.opcoesProcuradoresPJe = this.converterOpcoesProcuradores(this.dominioStore.procuradoresPJe);
            }
            await this.recuperarProcuradoresSessoes();
        } catch (error) {
            console.error(`Falha na inicialização do componente ProcuradorSessao: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente ProcuradorSessao', { cause: error });
        }
    }

    async recuperarProcuradoresSessoes() {
        for (let index in this.sessoes.slice()) {
            let procurador = await this.sessaoService.recuperarProcurador(this.sessoes[index].id);
            runInAction(() => (this.sessoes[index].procurador = procurador));
        }
    }

    get existeSessaoSIJ() {
        return this.sessoes.findIndex((sessao) => sessao.id.indexOf(Configuracao.ORIGEM_SIJ) !== -1) !== -1;
    }

    get existeSessaoPJe() {
        return this.sessoes.findIndex((sessao) => sessao.id.indexOf(Configuracao.ORIGEM_PJE) !== -1) !== -1;
    }

    converterOpcoesProcuradores = (procuradores) => {
        return procuradores.map((procurador) => {
            return {
                texto: procurador.codigo + ' - ' + procurador.nome,
                textoSecundario: procurador.descricaoClasse,
                valor: procurador
            };
        });
    };

    get sessoes() {
        return this.observableProps.sessoes;
    }

    isSessaoSIJ(idSessao) {
        return this.sessaoStore.isSessaoSIJ(idSessao);
    }

    get desabilitarAutoComplete() {
        return (
            this.sessaoStore.processosSessao.findIndex(
                (registro) =>
                    registro.processo.origem === Configuracao.ORIGEM_SIJ && !registro.necessitaImportacaoSalaSessao
            ) === -1
        );
    }

    render() {
        if (!this.isComponenteHabilitado('ProcuradorSessao')) {
            return null;
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', alignItems: 'center' }}>
                {this.sessoes.map((sessao) => {
                    return (
                        <Tooltip
                            key={'procurador' + sessao.id}
                            placement="bottom"
                            title={this.getTooltip(sessao)}
                        >
                            <div style={{ display: 'flex', width: '500px', margin: '4px 10px' }}>
                                <AutoComplete
                                    apresentarTextoSecundario
                                    value={this.getValorProcurador(sessao)}
                                    options={
                                        this.isSessaoSIJ(sessao.id)
                                            ? this.opcoesProcuradoresSIJ
                                            : this.opcoesProcuradoresPJe
                                    }
                                    onChange={(option) =>
                                        this.observableProps.callbackAutoComplete(option && option.valor, sessao.id)
                                    }
                                    label={'Procurador da sessão ' + sessao.descricao}
                                    disabled={sessao.origem === Configuracao.ORIGEM_SIJ && this.desabilitarAutoComplete}
                                />
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
        );
    }

    getValorProcurador(sessao) {
        let procurador;
        if (this.observableProps.procuradoresSelecionados) {
            procurador = this.observableProps.procuradoresSelecionados[sessao.id];
        } else {
            procurador = sessao.procurador;
        }
        return procurador && procurador.codigo !== 0 ? procurador.codigo + ' - ' + procurador.nome : null;
    }

    getTooltip(sessao) {
        return sessao.origem === Configuracao.ORIGEM_SIJ && this.desabilitarAutoComplete
            ? 'Não há processos do SIJ importados para alteração de procurador'
            : '';
    }
}

export default inject('stores')(observer(ProcuradorSessao));
